const apiDataFilterReducer = (
    state = {},
    action: {
      type: "SET_API_DATA_FILTER_OBJECT" ;
    //   | "CLEAR_ALL_API_TOKENS_FILTERS";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_API_DATA_FILTER_OBJECT":
        return { ...state, ...action.payload };
    //   case "CLEAR_ALL_API_TOKENS_FILTERS":
    //     return {};
      default:
        return state;
    }
  };
  
  export default apiDataFilterReducer;
  